import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ArkikWebComponentsModule } from '@core/modules';
import { ModalContainerComponent } from './modal-container.component';

@NgModule({
  declarations: [ModalContainerComponent],
  imports: [CommonModule, ArkikWebComponentsModule],
  exports: [ModalContainerComponent],
})
export class ModalContainerModule {}
